import React from "react"
import { useSelector } from "react-redux"
import Cookies from "js-cookie"
import EmptyState from "../Common/EmptyState"
import { translations } from "../../utils/Translation/staticTranslation"
import { getAppLanguage } from "../../utils/getAppLanguage"
import {
  canAccessOrganizationRoutes,
  shouldWaitForOrganizationProbe,
} from "../../utils/organizationAccess"

/**
 * Merchant portal: org management routes require is_org_owner (merchant JWT).
 */
const OrgOwnerRoute = ({ children }) => {
  const profileUser = useSelector((state) => state.user.user)
  const isOwner = useSelector((state) => state.organization.isOwner)
  const probeLoading = useSelector((state) => state.organization.probeLoading)
  const token = Cookies.get("token")
  const lang = getAppLanguage()
  const t = translations[lang]?.organizationPage

  if (shouldWaitForOrganizationProbe(profileUser, token, isOwner, probeLoading)) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <span className="text-14 text-8C8C80">Loading…</span>
      </div>
    )
  }

  if (!canAccessOrganizationRoutes(profileUser, isOwner)) {
    return (
      <div className="organization-team-page">
        <EmptyState
          title={t?.noActiveOrganizationTitle}
          description={t?.noActiveOrganizationDescription}
        />
      </div>
    )
  }

  return children
}

export default OrgOwnerRoute
